import { setCheckoutOverlay } from "./ui";
import { navigate } from '../helpers/navigationService';
import { deleteReservation, fetchReservation } from "./reservation";
import { refetchMember, setEmail, setName } from "../views/member/actions/member";
import request from "superagent";

export const setAuthStarted = (value) => ({ type: "SET_AUTH_STARTED", value })
export const loginPage = () => (dispatch, getState) => {
    const state = getState();
    const overlay = state.ui.overlay;

  if (!overlay) {
    dispatch(setCheckoutOverlay(true));
  }
  navigate('/auth');
};

export const login = (email: string, first_name: string = '', last_name: string = '', isCheckoutSSO = false) => async (dispatch, getState) => {
    const state = getState();
    const isGuest = email === '';
    if (state.reservation?.token && !isGuest) {
        await dispatch(refetchMember());
    }
    dispatch({ type: 'LOGIN', email, first_name, last_name, isCheckoutSSO});

    if(first_name !== '' && last_name !== '')
    {
        dispatch(setName(first_name + ' ' + last_name));
    }

    if(email !== '') {
        dispatch(setEmail(email));
    }

    // After SSO checkout login with an active reservation, get the reservation
    // again so server-updated fields, like rewardAmount, are updated.
    if (isCheckoutSSO) {
        const updatedState = getState();
        const token = updatedState.reservation?.token;
        const secret = updatedState.reservation?.secret;
        if (token && secret) {
            await dispatch(fetchReservation(token, secret)).catch(() => {});
        }
    }

    return Promise.resolve();
}

export const logout = (sendLogoutRequest: boolean = true) => (dispatch, getState) => {
  const {ui} = getState();

  if (!sendLogoutRequest) {
    dispatch(deleteReservation());
    dispatch({ type: 'LOGOUT' });
    return;
  }

  const url = ui.styleVars.GLOBAL__PARTNER__URL + '/sso/logout';
  request.post(url)
    .set('Content-Type', 'application/json')
    .send()
    .then(res => {
      if ((res.body) && (res.body.success)) {
        dispatch(deleteReservation());
        dispatch({ type: 'LOGOUT' });
      }
    });
};

